/**
 * CHG-052 REQ-V52-007: 이슈 타입 관리 React Query 훅
 */
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as issueTypeApi from '../services/issueTypeAdminService';
import type { CreateIssueTypeData, UpdateIssueTypeData } from '../services/issueTypeAdminService';
import { useOrgStore } from '../store/orgStore';

export const issueTypeAdminKeys = {
  all: (orgId?: string | null) => ['admin', 'issue-types', orgId ?? 'none'] as const,
};

export function useIssueTypes() {
  const activeOrgId = useOrgStore((s) => s.activeOrgId);
  return useQuery({
    queryKey: issueTypeAdminKeys.all(activeOrgId),
    queryFn: issueTypeApi.fetchIssueTypes,
  });
}

export function useCreateIssueType() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateIssueTypeData) => issueTypeApi.createIssueType(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin', 'issue-types'] }),
  });
}

export function useUpdateIssueType() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (params: { issueTypeId: string; data: UpdateIssueTypeData }) =>
      issueTypeApi.updateIssueType(params.issueTypeId, params.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin', 'issue-types'] }),
  });
}

export function useDeleteIssueType() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (issueTypeId: string) => issueTypeApi.deleteIssueType(issueTypeId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin', 'issue-types'] }),
  });
}
